'use client';

import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type SidebarStoreSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
};

export function SidebarStoreSearch({ value, onChange, placeholder }: SidebarStoreSearchProps) {
  const { t } = useTranslation('navigation');

  return (
    <div className="crm-sidebar-store-search">
      <Search className="crm-sidebar-store-search__icon" aria-hidden />
      <input
        type="search"
        enterKeyHint="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="crm-sidebar-store-search__input"
        aria-label={placeholder}
      />
      {value ? (
        <button
          type="button"
          className="crm-sidebar-store-search__clear"
          onClick={() => onChange('')}
          aria-label={t('clearStoreSearch')}
        >
          <X className="size-3" strokeWidth={2} />
        </button>
      ) : null}
    </div>
  );
}
